import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const IngredientContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  background: #ffffff;
  color: black;
  min-width: 259px;
  width: 259px;
  height: 275px;
  padding: 22px 24px;
  border: 2px solid #1d1d44;
  border-right: none;

  ${MEDIA_QUERIES.mdUp} {
    :nth-of-type(4) {
      border-right: 2px solid #1d1d44;
    }
  }

  ${MEDIA_QUERIES.xlUp} {
    :nth-of-type(5) {
      border-right: 2px solid #1d1d44;
    }
  }

  p,
  li {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const IngredientIntro = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
`;

export const IngredientTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const IngredientName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  span:first-of-type {
    font-family: var(--header-font);
    font-size: 50px;
    font-weight: 700;
    line-height: 45px;
  }

  span:last-of-type {
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
  }
`;

export const IngredientImage = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  margin-left: auto;
`;

export const IngredientDetails = styled.p`
  max-width: 180px;
  margin: ${SPACER.large} 0;
`;

export const IngredientTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: auto;
`;

export const IngredientTag = styled.li`
  font-weight: 700;
  background-color: #ff824f;
  padding: 1px 5px;
`;
